$(function () {
  $(".app-develop-content-nav li")
    .first()
    .find(".content-nav-line")
    .addClass("line-hover");
  $(".app-develop-content-nav li")
    .first()
    .find(".content-nav-title")
    .addClass("textColor");

  /********tab切换***********/
  $(".app-develop-content-nav").on("click", "li", function () {
    $(".app-develop-content-nav li")
      .find(".content-nav-line")
      .removeClass("line-hover");
    $(this).find(".content-nav-line").addClass("line-hover");
    $(".app-develop-content-nav li")
      .find(".content-nav-title")
      .removeClass("textColor");
    $(this).find(".content-nav-title").addClass("textColor");
    $(".app-wisdom").css("display", "none");
    $(".app-wisdom").eq($(this).index()).show();
  });
});
